import {kebabCase} from 'lodash';
import FormattedHTMLMessage from '../components/FormattedHTMLMessage';
import {resolveIntl} from '../stores/business/commonBusiness';

const intl = resolveIntl();

const unit = [
  '',
  'one ',
  'two ',
  'three ',
  'four ',
  'five ',
  'six ',
  'seven ',
  'eight ',
  'nine ',
  'ten ',
  'eleven ',
  'twelve ',
  'thirteen ',
  'fourteen ',
  'fifteen ',
  'sixteen ',
  'seventeen ',
  'eighteen ',
  'nineteen ',
];
const dozens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

export const digitInWords = (num) => {
  /* https://stackoverflow.com/questions/14766951/convert-digits-into-words-with-javascript */
  const numLocal = num.toString();

  if (numLocal.length > 9) return 'overflow';

  const n = `000000000 ${num}`.substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

  if (!n) return null;

  let str = '';
  str += parseInt(n[1], 10) !== 0 ? `${unit[Number(n[1])] || dozens[n[1][0]]} ${unit[n[1][1]]}crore ` : '';
  str += parseInt(n[2], 10) !== 0 ? `${unit[Number(n[2])] || dozens[n[2][0]]} ${unit[n[2][1]]}lakh ` : '';
  str += parseInt(n[3], 10) !== 0 ? `${unit[Number(n[3])] || dozens[n[3][0]]} ${unit[n[3][1]]}thousand ` : '';
  str += parseInt(n[4], 10) !== 0 ? `${unit[Number(n[4])] || dozens[n[4][0]]} ${unit[n[4][1]]}hundred ` : '';
  str +=
    parseInt(n[5], 10) !== 0 ? (str ? 'and ' : '') + (unit[Number(n[5])] || `${dozens[n[5][0]]} ${unit[n[5][1]]}`) : '';

  return str.trimRight();
};

/**
 * To add sequence index inside parentheses ()
 * @param {string} strName string
 * @param {string array} dataList string array
 */
export const sequenceName = (strName, dataList) => {
  if (strName) {
    const rcmnd = `${strName} (1)`;
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(strName);
    if (matches) {
      const fmtd = strName.replace(matches[1], '_').trim();
      if (!Number.isNaN(matches[1]) && fmtd.substring(fmtd.length - 4, fmtd.length) === ' (_)') {
        const lastIdx = fmtd.length - 4;
        const prefix = fmtd.substring(0, lastIdx);
        if (dataList) {
          const arrSuffix = [];
          dataList.map((data) => {
            if (data.substring(0, lastIdx).toLowerCase() === prefix.toLowerCase()) {
              const mtc = regExp.exec(data);
              if (mtc && !Number.isNaN(mtc[1])) arrSuffix.push(Number(mtc[1]));
            }
            return data;
          });
          if (arrSuffix.length > 0) {
            return `${prefix} (${Number(Math.max(...arrSuffix) + 1)})`;
          }
        }
      }
    }
    return dataList.includes(rcmnd) ? sequenceName(rcmnd, dataList) : rcmnd;
  }
  return '';
};

export const checkContainIllegalChars = (name) => name.match(/[|&;$%@"<>+,#^*|=\\/:?]/g) != null;

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  if (s.length === 0) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const lowercaseFirstWord = (s) => {
  if (typeof s !== 'string') return '';
  if (s.length === 0) return '';
  return s.charAt(0).toLowerCase() + s.slice(1);
};

export const findMaxWord = (words) => {
  if (!words) return 0;

  const wordArr = words.split(' ');
  const longestWord = wordArr.reduce((a, b) => (a.length > b.length ? a : b));
  return longestWord.length;
};

export const incrementName = (newName, existingNames) => {
  let txtStr = newName;
  const matchName = existingNames.filter((e) => e === txtStr);

  if (matchName.length === 0) {
    return txtStr;
  }

  const similarNames = existingNames.filter((e) => e.startsWith(txtStr)).sort();

  const roundBracketPattern = /\((.*)\)/;
  let nameCount = 0;

  for (let idx = 0; idx < similarNames.length; idx += 1) {
    const n = similarNames[idx];
    const index = n.replace(txtStr, '').trim();

    if (index.match(roundBracketPattern)) {
      const count = parseInt(index.match(roundBracketPattern)[1], 10);
      nameCount = Math.max(nameCount, count);
    }
  }

  nameCount += 1;
  txtStr = `${txtStr} (${nameCount})`;

  return txtStr;
};

export const getWordBreakClassName = (words, max) => {
  if (findMaxWord(words) >= max) {
    return 'break-all';
  }

  return '';
};

/**
 * Parse message ID
 * @param {String} id message ID
 * @param {Object} values values
 * @returns parsed message string/component
 */
export const parseMessage = (id, values) => {
  const stringMessage = intl.formatMessage({id}, values);
  const isNeedToBeReturnedAsComponent = stringMessage.match(/{[0-9A-z]*}|<\/[A-z]*>/gm);

  return isNeedToBeReturnedAsComponent ? <FormattedHTMLMessage id={id} values={values} /> : stringMessage;
};

export const upperCaseFirstLetter = (str) => {
  if (!str) return '';

  return str[0].toUpperCase() + str.slice(1);
};

export const toTitleCase = (string) => {
  if (!string) return '';

  return kebabCase(string)
    .split('-')
    .map((word) => upperCaseFirstLetter(word))
    .join(' ');
};
